<!-- src/components/statistics/KPICards.vue -->
<template>
  <div class="kpi-section">
    <h4 class="section-title">核心指标概览</h4>
    <div class="kpi-grid" v-loading="loading">
      <!-- 第1行：流量指标 -->
      <el-row :gutter="20" class="kpi-row">
        <el-col :xs="12" :sm="6" :md="8">
          <el-card class="kpi-card" shadow="hover">
            <div class="kpi-content">
              <div class="kpi-icon icon-blue">
                <i class="el-icon-chat-dot-round"></i>
              </div>
              <div class="kpi-info">
              <div class="kpi-value">{{ formatNumber(metrics.totalQueries) }}</div>
                <div class="kpi-label">总提问量</div>
              </div>
            </div>
          </el-card>
        </el-col>
        
        <el-col :xs="12" :sm="6" :md="8">
          <el-card class="kpi-card" shadow="hover">
            <div class="kpi-content">
              <div class="kpi-icon icon-green">
                <i class="el-icon-user"></i>
              </div>
              <div class="kpi-info">
                <div class="kpi-value">{{ formatNumber(metrics.uniqueSessions) }}</div>
                <div class="kpi-label">独立会话数</div>
              </div>
            </div>
          </el-card>
        </el-col>
        

        
        <el-col :xs="12" :sm="6" :md="6">
          <el-card class="kpi-card" shadow="hover">
            <div class="kpi-content">
              <div class="kpi-icon icon-purple">
                <i class="el-icon-question"></i>
              </div>
              <div class="kpi-info">
                <div class="kpi-value">{{ formatNumber(metrics.unknownQuestionCount) }}</div>
                <div class="kpi-label">未知问题数</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      
      <!-- 第2行：质量指标 -->
      <el-row :gutter="20" class="kpi-row">
        <el-col :xs="12" :sm="6" :md="8">
          <el-card class="kpi-card" shadow="hover">
            <div class="kpi-content">
              <div class="kpi-icon icon-success">
                <i class="el-icon-success"></i>
              </div>
              <div class="kpi-info">
                <div class="kpi-value">{{ metrics.hitRate }}%</div>
                <div class="kpi-label">问题命中率</div>
              </div>
            </div>
            <el-progress :percentage="metrics.hitRate" :stroke-width="4" 
              :color="getProgressColor(metrics.hitRate)" class="kpi-progress"></el-progress>
          </el-card>
        </el-col>
        
        <el-col :xs="12" :sm="6" :md="8">
          <el-card class="kpi-card" shadow="hover">
            <div class="kpi-content">
              <div class="kpi-icon icon-warning">
                <i class="el-icon-star-on"></i>
              </div>
              <div class="kpi-info">
                <div class="kpi-value">{{ metrics.positiveRatingRate }}%</div>
                <div class="kpi-label">用户好评率</div>
              </div>
            </div>
            <el-progress :percentage="metrics.positiveRatingRate" :stroke-width="4"
              :color="getProgressColor(metrics.positiveRatingRate)" class="kpi-progress"></el-progress>
          </el-card>
        </el-col>
        
        <el-col :xs="12" :sm="6" :md="8">
          <el-card class="kpi-card" shadow="hover">
            <div class="kpi-content">
              <div class="kpi-icon icon-primary">
                <i class="el-icon-circle-check"></i>
              </div>
              <div class="kpi-info">
                <div class="kpi-value">{{ metrics.aiResolutionRate }}%</div>
                <div class="kpi-label">AI直接解决率</div>
              </div>
            </div>
            <el-progress :percentage="metrics.aiResolutionRate" :stroke-width="4"
              :color="getProgressColor(metrics.aiResolutionRate)" class="kpi-progress"></el-progress>
          </el-card>
        </el-col>
        

      </el-row>
    </div>
  </div>
</template>

<script>
export default {
    name: "KPICards",
    props: {
      metrics: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
    },
mounted() {
  console.log('🔍 KPICards 收到的 metrics:', this.metrics)
  console.log('🔍 hit_rate:', this.metrics.hit_rate)
},    
  methods: {
    formatNumber(num) {
      if (num === null || num === undefined) return '0'
      if (num >= 10000) {
        return (num / 10000).toFixed(1) + '万'
      }
      return num.toString()
    },
    getProgressColor(percentage) {
      if (percentage >= 80) return '#67c23a'
      if (percentage >= 60) return '#e6a23c'
      return '#f56c6c'
    }
  }
}
</script>

<style scoped>
.kpi-section {
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  padding-left: 10px;
  border-left: 3px solid #409EFF;
}

.kpi-row {
  margin-bottom: 16px;
}

.kpi-card {
  border-radius: 8px;
  transition: transform 0.2s;
}

.kpi-card:hover {
  transform: translateY(-2px);
}

.kpi-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.kpi-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}

.icon-blue { background: #ecf5ff; color: #409EFF; }
.icon-green { background: #f0f9eb; color: #67c23a; }
.icon-orange { background: #fdf6ec; color: #e6a23c; }
.icon-purple { background: #f5f0ff; color: #722ed1; }
.icon-success { background: #f0f9eb; color: #67c23a; }
.icon-warning { background: #fdf6ec; color: #e6a23c; }
.icon-primary { background: #ecf5ff; color: #409EFF; }
.icon-danger { background: #fef0f0; color: #f56c6c; }

.kpi-info {
  flex: 1;
  min-width: 0;
}

.kpi-value {
  font-size: 26px;
  font-weight: 700;
  color: #303133;
  line-height: 1.2;
}

.kpi-label {
  font-size: 13px;
  color: #909399;
  margin-top: 4px;
}

.kpi-progress {
  margin-top: 12px;
}

@media (max-width: 768px) {
  .kpi-value {
    font-size: 20px;
  }
  
  .kpi-icon {
    width: 36px;
    height: 36px;
    font-size: 18px;
  }
}
</style>